import React, { useState, useEffect, useRef } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const processData = (data) => {
  return data
    .filter((item) => item.Fields !== "Total Inactive Voters")
    .map((item) => ({
      label: item.Fields,
      value: parseInt(item["No. of Voters"].replace(/,/g, ""), 10),
    }));
};

const InActiveVotersChart = ({ data }) => {
  const chartRef = useRef(null);
  const processedData = processData(data);
  const userIcon = new Image();
  userIcon.src = "/img/voterscount/red-user-icon.png";

  const [chartHeight, setChartHeight] = useState(500);

  useEffect(() => {
    const updateChartHeight = () => {
      if (window.innerWidth < 768) {
        setChartHeight(350);
      } else {
        setChartHeight(500);
      }
    };

    updateChartHeight();
    window.addEventListener("resize", updateChartHeight);

    return () => window.removeEventListener("resize", updateChartHeight);
  }, []);

  const chartData = {
    labels: processedData.map((item) => item.label),
    datasets: [
      {
        label: "No. of Inactive Voters",
        data: processedData.map((item) => item.value),
        borderColor: "rgba(220, 53, 69, 1)",
        backgroundColor: "rgba(220, 53, 69, 0.4)",
        fill: true,
        borderWidth: 3,
        tension: 0.4,
        pointRadius: 6,
        pointBackgroundColor: "rgba(220, 53, 69, 1)",
        // pointStyle: userIcon,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        right: 30,
      },
    },
    plugins: {
      legend: {
        position: "top",
        labels: {
          color: "#0142B2",
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Citizens",
          color: "#CB0C0C",
        },
        ticks: {
          color: "#0142B2",
          font: {
            size: 14,
          },
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of Inactive Voters",
          color: "#CB0C0C",
        },
        ticks: {
          color: "#0142B2",
          font: {
            size: 14,
          },
          callback: (value) => value.toLocaleString("en-US"),
        },
      },
    },
    // animation: {
    //   duration: 2000,
    //   easing: "easeInOutQuart",
    // },
  };

  const customPlugin = {
    id: "customIconsWithHover",
    afterDraw: (chart) => {
      const ctx = chart.ctx;
      const dataset = chart.data.datasets[0];

      chart.getDatasetMeta(0).data.forEach((point, index) => {
        const baseSize = 24;
        let imgSize = baseSize;

        if (chart.tooltip && chart.tooltip.dataPoints) {
          const hoveredPoint = chart.tooltip.dataPoints.find(
            (d) => d.index === index
          );
          if (hoveredPoint) {
            imgSize = baseSize * 1.3;
          }
        }

        const value = dataset.data[index].toLocaleString("en-US");

        // Draw Image Icon
        ctx.drawImage(
          userIcon,
          point.x - imgSize / 2,
          point.y - imgSize / 2,
          imgSize,
          imgSize
        );

        ctx.font = "bold 14px Arial";
        ctx.fillStyle = "#0142B2";
        ctx.textAlign = "center";
        ctx.cursor = "pointer";
        ctx.fillText(value, point.x, point.y - 20);
      });
    },
  };

  return (
    <div
      className="chart-container"
      style={{
        width: "100%",
        height: `${chartHeight}px`,
        margin: "0 auto",
        background: "transparent",
      }}
    >
      <Line
        ref={chartRef}
        data={chartData}
        options={options}
        plugins={[customPlugin]}
      />
    </div>
  );
};

export default InActiveVotersChart;
